import React from "react";

export class SignUp extends React.Component {
  render() {
    return <div>SignUp</div>;
  }
}
